import { PropsWithoutRef } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { SIDEBAR_WIDTH } from "../constants";

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <a
          href="/dashboard"
          onClick={(e) => {
            e.preventDefault();
            navigate("/dashboard");
          }}
          className="logo_link"
        >
          <figure>
            <img src="/static/images/logo.svg" alt="Magrudy Logo" />
            {/* <figcaption>Barber Shop</figcaption>
            <figcaption className="logo_sm">BS</figcaption> */}
          </figure>
        </a>

        <IconButton
          sx={{
            display: "none",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          onClick={handleSidebarToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        <Tooltip title="Dashboard" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/dashboard"}
            onClick={() => navigate("/dashboard")}
          >
            <ListItemIcon>
              <img src="/static/images/dashboard_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Dashboard" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Users" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-users" ||
              location.pathname === "/manage-users/edit" ||
              location.pathname === "/manage-users/detail"
            }
            onClick={() => navigate("/manage-users")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Users" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Rewards & Offers Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-rewards" ||
              location.pathname === "/manage-rewards/add" ||
              location.pathname === "/manage-rewards/detail"
            }
            onClick={() => navigate("/manage-rewards")}
          >
            <ListItemIcon>
              <img src="/static/images/reward_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Rewards & Offers Management"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Transactions & Loyalty Logs" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-transactions"||
              location.pathname === "/manage-transactions/view"

            }
            onClick={() => navigate("/manage-transactions")}
          >
            <ListItemIcon>
              <img src="/static/images/transaction_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Transactions & Loyalty Logs"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Promotion Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-promotions" ||
              location.pathname === "/manage-promotions/add" ||
              location.pathname === "/manage-promotions/edit" ||
              location.pathname === "/manage-promotions/view" 
            }
            onClick={() => navigate("/manage-promotions")}
          >
            <ListItemIcon>
              <img src="/static/images/offer_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Promotion Management" />
          </ListItemButton>
        </Tooltip>

        {/* <Tooltip title="QR Code Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-qr-code"}
            onClick={() => navigate("/manage-qr-code")}
          >
            <ListItemIcon>
              <img src="/static/images/qr_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="QR Code Management"
            />
          </ListItemButton>
        </Tooltip> */}

        <Tooltip title="Store Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-stores" ||
              location.pathname === "/manage-stores/add" ||
              location.pathname === "/manage-stores/detail"
            }
            onClick={() => navigate("/manage-stores")}
          >
            <ListItemIcon>
              <img src="/static/images/store_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Store Management" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Feedback, Reports & Logs" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-feedback-and-reports"}
            onClick={() => navigate("/manage-feedback-and-reports")}
          >
            <ListItemIcon>
              <img src="/static/images/report_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Feedback, Reports & Logs" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="System Settings" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-system-settings" ||
              location.pathname === "/manage-system-settings/add-email-template"
            }
            onClick={() => navigate("/manage-system-settings")}
          >
            <ListItemIcon>
              <img src="/static/images/settings.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="System Settings"
            />
          </ListItemButton>
        </Tooltip>
        
        <Tooltip title="Notification & Communication Center" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-notifications" ||
              location.pathname === "/manage-notifications/add" ||
              location.pathname === "/manage-notifications/detail"
            }
            onClick={() => navigate("/manage-notifications")}
          >
            <ListItemIcon>
              <img src="/static/images/notification2_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Notification Center"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Activity Logs" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-activity-logs"}
            onClick={() => navigate("/manage-activity-logs")}
          >
            <ListItemIcon>
              <img src="/static/images/logs_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Activity Logs"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Sub-Admin" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-subadmin" ||
              location.pathname === "/manage-subadmin/add" ||
              location.pathname === "/manage-subadmin/detail" ||
              location.pathname === "/manage-subadmin/roles" ||
              location.pathname === "/manage-subadmin/roles/add" ||
              location.pathname === "/manage-subadmin/roles/detail"
            }
            onClick={() => navigate("/manage-subadmin")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Sub-Admin" />
          </ListItemButton>
        </Tooltip>
        
        <Tooltip title="Manage CMS Pages" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-cms"}
            onClick={() => navigate("/manage-cms")}
          >
            <ListItemIcon>
              <img src="/static/images/cms_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage CMS Pages" />
          </ListItemButton>
        </Tooltip>
      </List>
    </>
  );
  return (
    <Box
      component="nav"
      sx={{
        width: mobileOpen ? SIDEBAR_WIDTH : 0,
        transition: "width 0.3s",
        overflowX: "hidden",
      }}
      className={mobileOpen ? "sidebar-main-div active" : "sidebar-main-div"}
    >
      <Drawer
        className="sidebar_drawer"
        variant="persistent"
        sx={{
          // display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
      {/* <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer> */}
    </Box>
  );
}
